export default __webpack_public_path__ + "static/media/welcomePageImg.7bd73d58.png";